import { Validator } from '@vista-digital/validator';
import { defaultMemberNameConfig, memberNameConfigValidator } from './config';
export const defaultMemberNameProps = {
    config: defaultMemberNameConfig
};
export const memberNamePropsValidator = Validator.object({ config: memberNameConfigValidator });
